import { createInertiaApp } from '@inertiajs/react'
import axios from 'axios'
import { createElement, type ReactNode } from 'react'
import { createRoot } from 'react-dom/client'

// Inertia's router uses axios under the hood. Rails issues its CSRF token via
// the <meta name="csrf-token"> tag and verifies it from the X-CSRF-Token header
// — but axios defaults to an XSRF-TOKEN cookie Rails never sets. Without this,
// every router mutation (e.g. router.delete("/logout")) fails CSRF verification
// with ActionController::InvalidAuthenticityToken.
const csrfToken = document
  .querySelector('meta[name="csrf-token"]')
  ?.getAttribute('content')
if (csrfToken) {
  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
}

type ResolvedComponent = {
  default: ReactNode
  layout?: (page: ReactNode) => ReactNode
}

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<ResolvedComponent>('../pages/**/*.tsx', {
      eager: true,
    })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.tsx'`)
    }
    return page
  },

  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(createElement(App, props))
    } else {
      console.error(
        'Missing root element. Move `vite_typescript_tag "inertia"` into an Inertia-specific layout.',
      )
    }
  },
})
